// extracted by mini-css-extract-plugin
module.exports = {"notification":"style__notification__nhr3T"};